<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading> -->
<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading> -->
<span class="user-reg">
  <div class="main-page">
    <div class="d-flex">
      <div class="col-md-2">
      </div>
      <div class="col-md-10">
        <div class="container">
          <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
          <div class="user-registration-page">
            <div class="innerPage user-registration-page-inner">
              <div class="d-flex justify-content-center"><small
                  class="mb-3 text-center mt-0 font-weight-bold text-white">All fields marked with
                asterisks(*) are required</small></div>
                <!-- <div class="d-flex justify-content-center"><small
                  class="mTop mb-3 text-center mt-0 font-weight-bold text-white border-bottom">(Would be great if the profile banner matched the full-width banner ad dimensions 1400x300)</small></div> -->
              <form class="form-signin" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
                <div class="row file-style">
                  <div class="col-sm-5 col-md-6  col-lg-4">
                    <div style="margin-left: 35px;" class="uploadProfileButton">
                      <div>
                        <input id="file1" type="file" name="profile1" (change)="uploadProfile($event)" />
                        <small style="max-width: 242px;" class="text-center text-white d-block">Max 300 x 300 (square)</small>
                        <label for="file1" class="btn-3">Upload Profile/Logo Image</label><br>
                      </div>
                      <div class="profile-image ml-5" *ngIf="profilePic">
                        <img [src]="checkImage(profilePic)" alt="test" width="" height=""
                          style="width: 130px; height: 130px;border-radius: 50%; margin-left: 12px;">
                      </div>
                      <input type="hidden" formControlName="photo"
                        [ngClass]="{ 'is-invalid': submitted && f.photo.errors }" />

                      <div *ngIf="submitted && f.photo.errors" class="invalid-feedback">
                        <div style="margin-bottom:10px;" class="error profileImage" *ngIf="f.photo.errors.required">Profile Image is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5 col-md-6  col-lg-4 coverImage" style="margin-left: 15px;" >
                    <input id="file2" type="file" name="profile" (change)="uploadBanner($event)" />
                    <small style="max-width: 285px;" class="text-center text-white d-block">Max 1400 x 300</small>
                    <div class="upload-file">
                    <label for="file2" class="btn-3" style="margin-left: 25px;">Upload Cover Image</label><br>
                  </div>
                    <div class="upload-image" style="text-align: center;" *ngIf="coverPhoto">
                      <img [src]="checkImage(coverPhoto)" alt="test" class="ml-xl-n4">
                    </div>
                    <input type="hidden" formControlName="coverPhoto"
                      [ngClass]="{ 'is-invalid': submitted && f.coverPhoto.errors }" />
                    <div *ngIf="submitted && f.coverPhoto.errors" class="invalid-feedback">
                      <div style="margin-bottom:10px;" class="error coverimage" *ngIf="f.coverPhoto.errors.required">Cover Image is required</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 ">
                    <div class="round-column">
                      <h5 class="text-center heading h5 mb-3 font-weight-bold">Business Info</h5>
                      <div class="form-group">
                        <div class="d-flex">
                          <span class="asterisk mr-2">*</span>
                          <div style="width: 100%;">
                            <label for="name" class="mb-1 text-white">Business Name</label>
                            <input type="text" class="form-control" formControlName="name" placeholder="Business Name"
                              [ngClass]="{'is-invalid': submitted && f.name.errors }">
                            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                              <div class="error" *ngIf="f.name.errors.required">Name is required</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="d-flex">
                          <span class="asterisk mr-2">*</span>
                          <div style="width: 100%;">
                            <div class="contact-h w-100 d-flex justify-content-between">
                              <label for="userName" class="text-white mb-1">Contact Name</label>
                              <label class="switch switch1">
                                <span style="margin-left: -37px;color: #fff;">Hide</span>
                                <i class="fa fa-asterisk" aria-hidden="true"></i>
                                <input [checked]="isBusinessContactNameVisible" type="checkbox" checked
                                  (click)="checkBusiness($event)">
                                <span class="slider round"></span>
                              </label>
                            </div>
                            <input type="text" class="form-control" formControlName="userName"
                              placeholder="Business Contact Name"
                              [ngClass]="{ 'is-invalid': submitted && f.userName.errors }">
                            <div *ngIf="submitted && f.userName.errors" class="invalid-feedback">
                              <div class="error" *ngIf="f.userName.errors.required">User Name is required</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="form-group  ml-3">
                          <label for="logline" class="mb-1 text-white">Business Slogan/ Motto</label>
                          <input type="text" class="form-control" formControlName="logLine"
                            placeholder="Business Slogan">
                        </div>
                        <div class="form-group">
                          <div class="d-flex">
                            <span class="asterisk mr-2">*</span>
                            <div style="width: 100%;">
                              <label for="shortBio" class="text-white mb-1">About Us</label>
                              <textarea type="text" class="form-control textareaa" name="shortBio"
                                formControlName="shortBio" placeholder="Business Description"
                                [ngClass]="{ 'is-invalid': submitted && f.shortBio.errors}"></textarea>
                              <div *ngIf="submitted && f.shortBio.errors" class="invalid-feedback">
                                <div class="error" *ngIf="f.shortBio.errors.required">Required</div>
                                <div *ngIf="f.shortBio.errors.minlength">Minimum 6 characters are required</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group ml-3">
                          <label for="bussinessHours" class="text-white mb-1">Business Hours</label>
                          <div>
                            <input type="text" [value]="bhours" class="form-control" formControlName="bussinessHours"
                              placeholder="Business Hours" (click)="openBusinessHour(businessHours)">
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="editor-tag">
                            <div class="d-flex">
                              <span class="asterisk mr-2">*</span>
                              <div class="w-100">
                                <label for="bussinessTypes" class="text-white mb-1">Business Category</label>
                                <div *ngIf="submitted && f.bussinessTypes.errors" class="invalid-feedback">
                                  <div class="error" *ngIf="f.bussinessTypes.errors.required">Website Name is required
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="tag-item-area ml-3">
                              <span class="tag-item" *ngFor="let tag of businessIds; let i = index;">
                                {{tag.tagName}}
                                <span class="remove-tag" (click)="removeTag(i)">×</span>
                              </span>
                              <input class="tag-input" type="text" placeholder="Add tag..."
                                (click)="openBusiness(business, $event)">
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                  <!---col-md-4-end-->
                  <div class="col-md-4">
                    <div class="round-column">
                      <h5 class="text-center heading h5 mb-3 font-weight-bold">Contact Info</h5>
                      <div class="form-group d-flex">
                        <span class="asterisk mr-2">*</span>
                        <div class="w-100 d-flex flex-wrap justify-content-between">
                          <label for="address" class="text-white mb-1">Address</label>
                          <label class="switch switch1">
                            <span style="margin-left: -85px;color: #fff;">Hide Street</span>
                            <i class="fa fa-asterisk" aria-hidden="true"></i>
                            <input [checked]="isShowStreetAddress" type="checkbox" checked
                              (click)="checkAddress($event)">
                            <span class="slider round"></span>
                          </label>
                          <input type="text" class="form-control" (click)="openAddress(address, 1)"
                            placeholder="Click to select address (Google)" formControlName="address"
                            [ngClass]="{ 'is-invalid': submitted && f.address.errors }" />
                          <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                            <div class="error" *ngIf="f.address.errors.required">Address is required</div>
                          </div>
                          <div *ngIf="submitted && !(form?.get('location')?.value?.coordinates && form?.get('location')?.value?.coordinates.length === 2)" class="invalid-feedback d-block">
                            <div class="error">Please select an address from Google suggestions. Manual entry is not valid.</div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group ml-3">
                        <label for="alternateAddress" class="mb-1 text-white">Address 2</label>
                        <input
                          type="text"
                          class="form-control"
                          name="alternateAddress"
                          placeholder="Suite / Unit / Apt (Optional)"
                          formControlName="address2"
                        />
                      </div>
                      <!-- Removed alternateAddresses list: Address 2 now only fills the input field -->
                      <!-- <div class="custom-control custom-switch align-items-center justify-content-between d-flex">
                        <label class="switch-top ml-3 mr-1" for="customSwitch1">Want to make business contact name
                          private?</label>

                      </div> -->
                      <div class="form-group ml-3">
                        <div class="row">
                          <div class="col-md-3 ">
                            <label for="phoneCode" class="mb-1 text-white">Code</label>
                            <input type="text" style="width: 60px !important;" class="form-control phonecode"
                              placeholder="+1" formControlName="phonecode">
                          </div>
                          <div class=" col-md-9">
                            <label for="contactNo" class="mb-1 text-white">Phone</label>
                            <input type="text" style="margin-left:10px;" class="form-control phoneno" name="contactNo"
                              placeholder="Contact Number(Optional)" formControlName="contactNo">
                              <div *ngIf="submitted && f.contactNo.errors" class="invalid-feedback">
                                <div *ngIf="f.contactNo.errors.required">Phone No is required</div>
                                <div *ngIf="f.contactNo.errors.email">Phone must be a valid Phone no.</div>
                              </div>
                          </div>

                        </div>
                      </div>
                      <div class="form-group">
                        <div class="d-flex">
                          <span class="asterisk mr-2">*</span>
                          <div class=" w-100">
                            <label for="email" class="mb-1 text-white">Email</label>
                            <input style="color:grey !important;" type="email" class="form-control" formControlName="email" placeholder="Enter email"
                              name="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                              [readonly]="true">
                            <!-- <img src="assets/eye.png" width=25 /> -->
                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                              <div *ngIf="f.email.errors.required">Email is required</div>
                              <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="d-flex ">
                          <span class="asterisk mr-2">*</span>
                          <div class="w-100">
                            <label for="website" class="mb-1 text-white">Website</label>
                            <input type="text" class="form-control" formControlName="website" placeholder="website"
                              name="website" [ngClass]="{ 'is-invalid': submitted && f.website.errors }">
                            <div *ngIf="submitted && f.website.errors" class="invalid-feedback">
                              <div class="error" *ngIf="f.website.errors.required">Website Name is required</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Links Section -->
                      <div class="form-group ml-3">
                        <label class="mb-1 text-white font-weight-bold">Links</label>
                        <div class="form-group">
                          <label for="iosAppStoreLink" class="mb-1 text-white">iOS App Store Link</label>
                          <input type="text" class="form-control" formControlName="iosAppStoreLink"
                            placeholder="https://apps.apple.com/..." name="iosAppStoreLink">
                        </div>
                        <div class="form-group">
                          <label for="androidAppStoreLink" class="mb-1 text-white">Android App Store Link</label>
                          <input type="text" class="form-control" formControlName="androidAppStoreLink"
                            placeholder="https://play.google.com/..." name="androidAppStoreLink">
                        </div>
                      </div>
                      <!-- Social Links Section -->
                      <div class="form-group ml-3">
                        <label class="mb-1 text-white font-weight-bold">Social Links</label>
                        <button type="button" class="btn btn-sm btn-outline-light mb-2" (click)="openSocialLinks(socialLinksModal)">
                          <i class="fa fa-plus mr-1"></i>Add Social Links
                        </button>
                        <div class="social-links-display mt-2">
                          <div *ngIf="form.get('facebookLink')?.value" class="mb-1">
                            <i class="fab fa-facebook mr-2"></i>
                            <span class="text-white">{{ form.get('facebookLink')?.value }}</span>
                          </div>
                          <div *ngIf="form.get('instagramLink')?.value" class="mb-1">
                            <i class="fab fa-instagram mr-2"></i>
                            <span class="text-white">{{ form.get('instagramLink')?.value }}</span>
                          </div>
                          <div *ngIf="form.get('youtubeLink')?.value" class="mb-1">
                            <i class="fab fa-youtube mr-2"></i>
                            <span class="text-white">{{ form.get('youtubeLink')?.value }}</span>
                          </div>
                          <div *ngIf="form.get('linkedinLink')?.value" class="mb-1">
                            <i class="fab fa-linkedin mr-2"></i>
                            <span class="text-white">{{ form.get('linkedinLink')?.value }}</span>
                          </div>
                          <div *ngIf="form.get('tiktokLink')?.value" class="mb-1">
                            <i class="fab fa-tiktok mr-2"></i>
                            <span class="text-white">{{ form.get('tiktokLink')?.value }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group register-input"
                        [class.has-error]="f.businessUserName.errors && (f.submitted || f.businessUserName.touched)">
                        <div class="d-flex">
                          <span class="asterisk mr-2">*</span>
                          <div class="w-100">
                            <label class="mb-1 text-white">User Name (no spaces)</label>
                            <input type="text" formControlName="businessUserName"
                              [ngClass]="{ 'is-invalid': submitted && f.businessUserName.errors }">
                            <div *ngIf="f.businessUserName.errors && (f.submitted || f.businessUserName.touched)">
                              <div class="text-white text-left" *ngIf="f.businessUserName.errors.required">Username is
                                required.</div>
                              <div class="text-white text-left" *ngIf="f.businessUserName.errors.minlength">
                                Username must be at least 6 characters long.
                              </div>
                              <div class="text-white text-left"
                                *ngIf="f.businessUserName.errors.whitespaceOrSpecialCharacter">
                                Username cannot contain whitespace or special characters.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!---col-md-4-end-->
                  <div class="col-md-4 ">
                    <div class="round-column">
                      <h5 class="text-center heading mb-2 h5 mb-3 font-weight-bold">Faith & Community</h5>
                      <div class="form-group">
                        <div class="d-flex">
                          <span class="asterisk mr-2">*</span>
                          <div class="w-100">
                            <label for="faith" class="mb-1 text-white">Faith</label>
                            <input name="faith" (click)="openFaith(faith)" type="text" class="form-control mb-1"
                              placeholder="Select Faith" formControlName="faithName"
                              [ngClass]="{ 'is-invalid': submitted && f.faithName.errors }">

                            <input name="subFaith" (click)="openFaith(faith)" type="text" class="form-control mb-1"
                              placeholder="Faith Level 2" formControlName="subfaithName">

                            <input name="subFaith2" (click)="openFaith(faith)" type="text" class="form-control"
                              placeholder="Faith Level 3" formControlName="subfaith2Name">

                            <div *ngIf="submitted && f.faithName.errors" class="invalid-feedback">
                              <div class="error" *ngIf="f.faithName.errors.required">Faith is required</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group bg-lock-icon">
                        <span style="position: unset !important;" class="asterisk mr-2">*</span>
                        <div class="w-100">
                          <label for="affiliatedBy" class="mb-1 text-white">Primary Ministry Affiliation</label>
                          <input type="text" name="affiliatedBy" class="form-control " formControlName="affiliatedBy"
                            placeholder="Primary Ministry Affiliation" (click)="openCommunity(community)"
                            [ngClass]="{ 'is-invalid': submitted && f.affiliatedBy.errors }">
                          <span>{{affiliation}}</span>
                          <img (click)="openProfilePrivacy(profilePolicy)" src="assets/privacy_icon.png" width=25 />
                          <div *ngIf="submitted && f.affiliatedBy.errors" class="invalid-feedback">
                            <div class="error" *ngIf="f.affiliatedBy.errors.required">Fellowship Affiliation is required
                            </div>
                          </div>
                        </div>
                      </div>
                      <div  style="margin-left:16px;margin-bottom: 10px;">
                        <label for="title" class="mb-1 text-white">Our Values / Statement of Faith</label>
                        <!-- <input type="text" name="menu" class="form-control" formControlName="menu" [(ngModel)]="valueAndFaith" > -->
                        <textarea
                        name="menu"
                        class="form-control custom-textarea"
                        rows="4"
                        [(ngModel)]="valueAndFaith"
                        formControlName="menu">
                     </textarea>
                      </div>
                      <!-- <div (click)="showDiv=!showDiv" class="row">
                        <div class="clickText col-md-9 ">Click to add a custom field</div>
                        <div class="col-md-2">
                          <span class="plus-icon" type="button"  (click)="addCategory()"
                            style="float:right;">
                            <i class="fa fa-plus"></i>
                          </span>
                        </div>
                      </div>

                      <div *ngIf="!showDiv" formArrayName="category">
                        <div *ngFor="let category of categoryControls; let i = index">
                          <div *ngIf="i < 2" [formGroupName]="i">

                            <div class="row" *ngIf="i == 1">
                              <div class="col-md-9">
                                <label for="title" class="mt-2 ml-2 mb-1 text-white">
                                  Add Title
                                </label>
                              </div>
                            </div>
                            <input *ngIf="i == 1"
                                   class="form-control category-top"
                                   type="text"
                                   formControlName="title"
                                   name="title"
                                   placeholder="ex. Menu, Catalog or Services"
                                   [ngClass]="{'is-invalid': isTitle && i == 0}"
                                   (ngModelChange)="getInputChange($event, 'title')"
                                   style="width:230px !important;margin-left:16px !important;">
                            <div class="row" *ngIf="i == 1">
                              <div class="col-md-9">
                                <label for="title" class="mb-1 ml-2 text-white" style="display: block; width: 254px;">
                                  Add Details
                                </label>
                              </div>
                            </div>
                            <input *ngIf="i == 1"
                                   class="form-control"
                                   type="text"
                                   formControlName="description"
                                   name="description"
                                   placeholder="Ex. Pizza, Pasta and Salad"
                                   [ngClass]="{'is-invalid': isDescription && i == 1}"
                                   style="width:230px !important;margin-left:16px !important;">

                          </div>
                        </div>
                      </div> -->

                      <div (click)="showDiv=!showDiv" class="row">
                        <div class="clickText col-md-9">Click to add a custom field</div>
                        <div class="col-md-2">
                            <span class="plus-icon" type="button" (click)="addCategory()" style="float:right;">
                                <i class="fa fa-plus"></i>
                            </span>
                        </div>
                    </div>

                    <div *ngIf="!showDiv" formArrayName="category">
                        <div *ngFor="let category of categoryControls; let i = index">
                            <div *ngIf="i < 2" [formGroupName]="i">
                                <div class="row" *ngIf="i == 1">
                                    <div class="col-md-9">
                                        <label for="title" class="mt-2 ml-2 mb-1 text-white">
                                            Add Title
                                        </label>
                                    </div>
                                </div>
                                <input *ngIf="i == 1"
                                       class="form-control category-top"
                                       type="text"
                                       formControlName="title"
                                       name="title"
                                       placeholder="ex. Menu, Catalog or Services"
                                       [ngClass]="{'is-invalid': (category.get('title')?.touched || submitted) && category.get('title')?.invalid}"
                                       (ngModelChange)="getInputChange($event, 'title')"
                                       style="width:230px !important;margin-left:16px !important;">
                                <div *ngIf="(category.get('title')?.touched || submitted) && category.get('title')?.invalid" class="invalid-feedback">
                                    Title is required
                                </div>

                                <div class="row" *ngIf="i == 1">
                                    <div class="col-md-9">
                                        <label for="description" class="mb-1 ml-2 text-white" style="display: block; width: 254px;">
                                            Add Details
                                        </label>
                                    </div>
                                </div>
                                <input *ngIf="i == 1"
                                       class="form-control"
                                       type="text"
                                       formControlName="description"
                                       name="description"
                                       placeholder="Ex. Pizza, Pasta and Salad"
                                       [ngClass]="{'is-invalid': (category.get('description')?.touched || submitted) && category.get('description')?.invalid}"
                                       style="width:230px !important;margin-left:16px !important;">
                                <div *ngIf="(category.get('description')?.touched || submitted) && category.get('description')?.invalid" class="invalid-feedback">
                                    Description is required when title is provided
                                </div>
                            </div>
                        </div>
                    </div>
                      <br>
                    </div>
                  </div>
                  <!---col-md-4-end-->
                </div>
                <div class="row" style="margin-top: 15px;">
                  <div class="col-md-12 ">

                    <div class="agree-text">
                      <div *ngIf="isTerms">
                        <p style="color: antiquewhite;"><a style="text-decoration-color: black;color: antiquewhite;"
                            class="color" href="https://ravel.faith/policies/ravel-terms/" target="_blank">Terms of
                            Services
                          </a><span>
                            and </span><a style="color: antiquewhite;" class="color"
                            href="https://ravel.faith/policies/privacy-policy/" target="_blank">Privacy
                            Policy</a> <span> <input [checked]="isChecked" type="checkbox"
                              class="form-check-input cursor" id="exampleCheck1"
                              style="margin-left: 8px; margin-top:5px!important"
                              (change)="checkCheckBoxvalue($event)"></span></p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-3"></div>
                        <div class="col-md-6 d-flex ">
                          <button type="button" routerLink="/dashboard"
                            class="text-center cancel-btn btn-color btn btn-danger">Cancel</button>
                          <button type="submit" class="text-center sign-up-btn btn-color btn btn-primary" [disabled]="!(form?.get('location')?.value?.coordinates && form?.get('location')?.value?.coordinates.length === 2)">Save</button>
                        </div>
                        <div class="col-md-3"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <button class="btn btn-lg btn-outline-primary" (click)="open(mymodal)">Open My Modal</button> -->
    <ng-template #communityAffliation let-modal>
      <div class="modal-header">
        <span>Filters</span>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body filter-body">
        <form [formGroup]="communitySearch">
          <h4 class="filter-text"><span>Filter By</span></h4>
          <div class="filter-image">
            <img alt="test" width="" height="" style=" width: 50px;
      height: 50px; border-radius: 50%;margin-top: 10px;" src="assets/church_image.jpg">
          </div>
          <h4><span>Filter By Keyword</span></h4>
          <div class="input-group">
            <input formControlName="search" placeholder="Keyword" class="form-control"
              style="background: #fff !important;" />
            <!-- <input  (input)="community1($event.target.value)">  -->
            <!-- <input type="text" class="form-control" placeholder="Search"   (input)="community(0,10, 'a')" [ngModelOptions]="{standalone: true}"> -->
            <div class="input-group-btn">
            </div>
          </div>
          <h4><span>Filter By Zip/Postal Code</span></h4>
          <input type="text" class="form-control" formControlName="areaCode" placeholder="Zip/Postal Code">
          <!-- <input type="text" class="form-control" placeholder="Keyword" [(ngModel)]="search" (change)="search()"> -->
          <h4><span>Filter By Faith/Denomination</span></h4>
          <input type="text" class="form-control" formControlName="faithName" placeholder="Faith/Denomination"
            (click)="openFaith(faith)">
          <h4><span>Filter by Address</span></h4>
          <!-- <input type="text" class="form-control" ngx-google-places-autocomplete
              (onAddressChange)="communityAddress($event)" /> -->

          <app-auto (setAddress)="communityAddress($event)" [strictBounds]="boundsLimit" [LatLng]="defaultBounds"
            adressType="geocode"></app-auto>

          <div class="row" style="    margin-top: 30px;
            ">
            <div class="col-md-12">
              <div>
                <div style="display: inline-block;
                    width: 100%;
                    text-align: end;">
                  <label style="float: left">Limit results to current region</label>
                  <div class="custom-control custom-switch">
                    <label class="switch">
                      <i class="fa fa-asterisk" aria-hidden="true"></i>
                      <input type="checkbox" checked (click)="limitCheckbox($event)">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <input type="text" class="form-control" formControlName="city" placeholder="City">
          <input type="text" class="form-control" formControlName="state" placeholder="State">
          <input type="text" class="form-control" formControlName="country" placeholder="Country">
          <div class="modal-footer select">
            <button type="button" class="btn btn-color btn-outline-dark filter-save"
              (click)="community_affliation(communitySearch.value)">Save</button>
          </div>
        </form>
      </div>
    </ng-template>
    <!-- Faith Modal -->
    <ng-template #faith let-modal>
      <div class="modal-header">
        <span>Faith</span>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body faith" style="height: 400px;overflow: scroll; overflow-x: hidden;">
        <!-- <div class="card " *ngFor="let faith of faithList">
            <div class="row">
              <div class="col-md-2">
                <div><img [src]="checkImage(faith.photo)? checkImage(faith.photo) : 'assets/default-user.jpg' " width=50>
                </div>
              </div>
              <div class="col-md-7 ">
                <div class="faith-text">{{faith.name}}</div>
              </div>
              <div class="col-md-2 pull-right">
                <div class="checkbox-click"><input type="checkbox" (click)="selectFaith(faith._id, faith.name, 1)"></div>
              </div>
            </div>
          </div> -->

        <!-- <ng-select>
          <ng-option *ngFor="let faith of faithList" [value]="faith._id">{{faith.name}}</ng-option>
        </ng-select> -->
        <form [formGroup]="form">

          <!-- 1st Level Faith -->
          <div class="form-group mb-3 required-field">
            <ng-select
              [items]="faithList"
              formControlName="faith"
              bindLabel="name"
              bindValue="_id"
              placeholder="Select Faith"
              [(ngModel)]="selectedFaith"
              (change)="changeFaith($event)"
            >
              <ng-template ng-header-tmp>
                <small class="form-text text-muted">
                  Loaded {{ skip1 }} of {{ faithTotalRecord }}
                </small>
              </ng-template>
              <div>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </div>
            </ng-select>
          </div>

          <!-- ** second level faith -->
          <div class="form-group mb-3 required-field"> <!-- Add the 'required-field' class here -->
            <ng-select
              formControlName="faith2"
              [items]="faithListLevel2"
              [(ngModel)]="selectedFaith2"
              [virtualScroll]="true"
              bindLabel="name"
              bindValue="_id"
              [placeholder]="'Faith level 2'"
              (change)="changeSubFaith($event)">
              <div>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </div>
            </ng-select>
          </div>

          <!-- ** 3rd level faith -->
          <div class="form-group">
            <ng-select formControlName="faith3" [items]="faithListLevel3" [virtualScroll]="true" [loading]="loading"
              bindLabel="name" bindValue="_id" [(ngModel)]="selectedFaith3" [placeholder]="'Faith level 3'" (change)="changeSubFaith2($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index">
                {{ item.name }}
              </ng-template>
            </ng-select>
          </div>

        </form>


      </div>
      <div class="modal-footer ">
        <button type="button" class="faith-select btn-color btn btn-outline-dark"
          (click)="modal.close('Save click')">Select</button>
      </div>
    </ng-template>
    <!-- Business Modal -->
    <ng-template #business let-modal>
      <div class="modal-header business-modal">
        <span>Business Category</span>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body business-body" style="height: 400px;overflow: scroll; overflow-x: hidden;">
        <div class="row justify-content-center">
          <div class="mb-3 w-50">
            <input type="text" class="form-control" (keyup)="onInputChange($event)" style="border: 1px solid lightgrey;"
              placeholder="Search">
          </div>
        </div>
        <div *ngIf="bussinessList?.length == 0" class="row justify-content-center mt-3">
          No Result Found
        </div>
        <ngb-accordion class="accordion-text">
          <ngb-panel title="{{business.category}}" *ngFor="let business of bussinessList; let ids = index">
            <ng-template ngbPanelContent>
              <div *ngFor="let n of business.name let i = index;" class="card">
                <div class="row">
                  <div class="col-md-2">
                    <input class="form-control" type="checkbox"
                      (click)="selectBusinessType(business._id, n._id, n.tag)">
                  </div>
                  <div class="col-md-8">
                    {{n.tag}}
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
      <div class="modal-footer ">
        <button type="button" class="Select-button btn btn-color btn-outline-dark"
          (click)="modal.close('Save click')">Select</button>
      </div>
    </ng-template>
    <!-- Community Modal -->
    <ng-template #community let-modal>
      <div class="modal-header" style="display: flex;">
        <div style="display: flex;">
          <div class="form-group">
            <input style="background-color: #fff !important;" type="text" [ngModel]='text'
              (ngModelChange)='searchCommunity($event)' class="form-control" placeholder="Search" />
          </div>
          <div style="margin-left: 10px;">
            <div (click)="openCommunityAffiliation(communityAffliation)"><img src="assets/cum-search.png"
                style="width: 45px;cursor: pointer;"></div>
          </div>
        </div>

        <div class="affiliation-header">
          <div>
            <p class="mb-0">Can't find a ministry? Suggest One!</p>
            <button type="button" class="btn btn-block w-50 mx-auto btn-warning mt-1"
              (click)="openSuggestMinistry(suggestMinistry)">Suggest a
              Ministry</button>
          </div>

          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="modal-body belivers" style="height: 400px;overflow: scroll; overflow-x: hidden;">
        <div class="card" *ngFor="let community of communityList">
          <div class="row">
            <div class="col-md-2">
              <div><img [src]="checkImage(community?.photo) ? checkImage(community?.photo):'assets/default-user.jpg'"
                  width=50></div>
            </div>
            <div class="col-md-7 ">
              <div>{{community?.name}}</div>
              <div> {{community?.address?.streetAddress}}</div>
            </div>
            <div class="col-md-2 pull-right">
              <div class="belivers-checkbox"><input type="checkbox"
                  (click)="selectComunitty(community?._id, community?.name)"></div>
            </div>
          </div>
        </div>
        <div *ngIf="communityList && communityList?.length == 0" class="text-center my-4">
          <span class="d-block">
            <i class="bi bi-minecart d-block font-weight-bold nodata-cart"></i>
          </span>
          <p class="font-weight-bold h3">No Data Found</p>
          <!-- <button type="button" class="btn btn-block btn-warning my-3" (click)="focusOnInput()">Retry</button>
                  <h5>OR</h5> -->
          <!-- <h5>The Ministry you are searching for was not found in our records.</h5>
          <h6>Please help us build our community by making a suggestion and we will reserach it. To be include in the
            Ravel ministry directory, organizations must qualify as a non-profit, faith based ministry.</h6>
          <button type="button" class="btn btn-block w-50 mx-auto btn-warning my-3"
            (click)="openSuggestMinistry(suggestMinistry)">Suggest a
            Ministry</button> -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="belivers-select btn btn-color btn-outline-dark" (click)="modal.close('Save click')"
          *ngIf="communityList && communityList?.length != 0">Select</button>
      </div>
    </ng-template>
    <!-- Address Modal -->
    <ng-template #address let-modal>
      <div class="modal-header address-popup">
        <span>Address </span>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body address-popup-body">
        <form [formGroup]="addressMain">
          <div class="form-group">
            <!-- <div class="container">  -->
            <!-- <input ngx-google-places-autocomplete  #placesRef="ngx-places" (onAddressChange)="AddressChange($event)"/>  -->
            <!-- <input type="text" class="form-control" ngx-google-places-autocomplete
                (onAddressChange)="AddressChange($event)" [options]='options' /> -->
            <app-auto (setAddress)="AddressChange($event)" [strictBounds]="boundsLimit" [LatLng]="defaultBounds"
              adressType="geocode" title="Address"></app-auto>
            <div class="mt-2" *ngIf="!hasGoogleSelection || !(addressMain?.get('location')?.value?.coordinates && addressMain?.get('location')?.value?.coordinates.length === 2)">
              <small class="text-danger">Please select a result from Google suggestions. Manual typing is not valid and Save is disabled until a place is selected.</small>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div>
                  <div style="display: inline-block;
                    width: 100%;
                    text-align: end;
                    margin-top: 10px;">
                    <label style="float: left; width: 90%;">Limit results to current region</label>
                    <div class="custom-control custom-switch">
                      <label class="switch">
                        <i class="fa fa-asterisk" aria-hidden="true"></i>
                        <input type="checkbox" checked (click)="limitCheckbox($event)">
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="isAddress">
              <div class="col-md-6">
                <input class="form-control" type="text" name="streetAddress" formControlName="streetAddress"
                  placeholder="Street Address" style="width: 715px;">
              </div>

              <!-- <div class="col-md-6">
                <input class="form-control" type="text" name="suite_no" formControlName="suite_no"
                  placeholder="Suite No ">
              </div> -->
            </div>
            <div class="row" *ngIf="isAddress">
              <div class="col-md-6">
                <input class="form-control" type="text" name="city" formControlName="city" placeholder="City">
              </div>
              <div class="col-md-6">
                <input class="form-control" type="text" name="state" formControlName="state" placeholder="State">
              </div>
            </div>
            <div class="row" *ngIf="isAddress">
              <div class="col-md-6">
                <input class="form-control" type="text" name="postalCode" formControlName="postalCode"
                  placeholder="Postal Code">
              </div>
              <div class="col-md-6">
                <input class="form-control" type="text" name="country" formControlName="country" placeholder="Country">
              </div>
            </div>
            <br>
            <button type="button" (click)="addAddress(addressMain.value)" [disabled]="!hasGoogleSelection || !(addressMain?.get('location')?.value?.coordinates && addressMain?.get('location')?.value?.coordinates.length === 2)" style="    display: inline-block;
            border-radius: 5px;
            box-shadow: 0px 0px 2px #888;
            color: white;
            background: chocolate;
            border: 1px solid chocolate;
            float: right;
            width: 60px;
            height: 40px;">Save</button>
            <br>
          </div>
        </form>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Select</button>
      </div> -->
    </ng-template>
    <!-- Business Hours Modal -->
    <ng-template #businessHours let-modal>
      <div class="modal-header modal-business-header">
        <span>Business Hours</span>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body business-hour" style="height: 400px;overflow: scroll; overflow-x: hidden; margin-top:25px">
        <form [formGroup]="formBusiness">
          <ngb-accordion>
            <ngb-panel title="Sunday">
              <ng-template ngbPanelContent class="input-form">
                <div formArrayName="Sunday" *ngFor="let b of formBusiness.get('Sunday')['controls']; let i = index">
                  <div [formGroupName]="i">
                    <div class="row fCust">
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Start" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Start"></timepicker>


                      </div>
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Finish" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Finish"></timepicker>


                      </div>
                      <div class="col-md-2 link" (click)="removeBusinessHour(i, 'Sunday')">X</div>
                    </div>
                  </div>
                </div>
                <br>
                <button type="button" (click)="addSunItem()" style="margin-right: 5px; color:black">Add More
                  Hours</button>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Monday">
              <ng-template ngbPanelContent>
                <div formArrayName="Monday" *ngFor="let b of formBusiness.get('Monday')['controls']; let i = index">
                  <div [formGroupName]="i">
                    <div class="row fCust">
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Start" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Start"></timepicker>
                      </div>

                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Finish" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Finish"></timepicker>

                      </div>
                      <div class="col-md-2 link" (click)="removeBusinessHour(i, 'Monday')">X</div>
                    </div>
                  </div>
                </div>
                <br>
                <button type="button" (click)="addMonItem()" style="margin-right: 5px; color: black;">Add More
                  Hours</button>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Tuesday">
              <ng-template ngbPanelContent>
                <div formArrayName="Tuesday" *ngFor="let b of formBusiness.get('Tuesday')['controls']; let i = index">
                  <div [formGroupName]="i">
                    <div class="row fCust">
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Start" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Start"></timepicker>


                      </div>
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Finish" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Finish"></timepicker>


                      </div>
                      <div class="col-md-2 link" (click)="removeBusinessHour(i, 'Tuesday')">X</div>
                    </div>
                  </div>
                </div>
                <br>
                <button type="button" (click)="addTuesItem()" style="margin-right: 5px; color: black;">Add More
                  Hours</button>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Wednesday">
              <ng-template ngbPanelContent>
                <div formArrayName="Wednesday"
                  *ngFor="let b of formBusiness.get('Wednesday')['controls']; let i = index">
                  <div [formGroupName]="0">
                    <div class="row fCust">
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Start" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Start"></timepicker>

                      </div>
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Finish" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Finish"></timepicker>

                      </div>
                      <div class="col-md-2 link" (click)="removeBusinessHour(i, 'Wednesday')">X</div>
                    </div>
                  </div>
                </div>
                <br>
                <button type="button" (click)="addWedItem()" style="margin-right: 5px; color: black;">Add More
                  Hours</button>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Thursday">
              <ng-template ngbPanelContent>
                <div formArrayName="Thursday" *ngFor="let b of formBusiness.get('Thursday')['controls']; let i = index">
                  <div [formGroupName]="i">
                    <div class="row fCust">
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Start" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->

                        <timepicker formControlName="Start"></timepicker>
                      </div>
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Finish" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Finish"></timepicker>

                      </div>
                      <div class="col-md-2 link" (click)="removeBusinessHour(i, 'Thursday')">X</div>
                    </div>
                  </div>
                </div>
                <br>
                <button type="button" (click)="addThursItem()" style="margin-right: 5px; color: black;">Add More
                  Hours</button>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Friday">
              <ng-template ngbPanelContent>
                <div formArrayName="Friday" *ngFor="let b of formBusiness.get('Friday')['controls']; let i = index">
                  <div [formGroupName]="i">
                    <div class="row fCust">
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Start" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Start"></timepicker>

                      </div>
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Finish" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Finish"></timepicker>

                      </div>
                      <div class="col-md-2 link" (click)="removeBusinessHour(i, 'Friday')">X</div>
                    </div>
                  </div>
                </div>
                <br>
                <button type="button" (click)="addFriItem()" style="margin-right: 5px; color: black;">Add More
                  Hours</button>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Saturday">
              <ng-template ngbPanelContent>
                <div formArrayName="Saturday" *ngFor="let b of formBusiness.get('Saturday')['controls']; let i = index">
                  <div [formGroupName]="i">
                    <div class="row fCust">
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Start" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Start"></timepicker>
                      </div>
                      <div class="col-md-5  md-outline box">
                        <!-- <timepicker formControlName="Finish" [showMeridian]="isMeridian" [readonlyInput]="!readonly"></timepicker> -->
                        <timepicker formControlName="Finish"></timepicker>
                      </div>
                      <div class="col-md-2 link" (click)="removeBusinessHour(i, 'Saturday')">X</div>
                    </div>
                  </div>
                </div>
                <br>
                <button type="button" (click)="addSatItem()" style="margin-right: 5px; color: black;">Add More
                  Hours</button>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-color btn-outline-dark select-dark-button"
          (click)="createBusinessHours(formBusiness.value)">Select</button>
      </div>
    </ng-template>
  </div>
  <!-- address -->
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <div class="row">
        <div type="button" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">X</span>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="container">
        <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()"
          placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
          #search>

        <!-- <input type="text" class="form-control" ngx-google-places-autocomplete placeholder="Add Location"
            (onAddressChange)="AddressChange($event)" /> -->
      </div>
      <form class="form-signin" [formGroup]="addressMain">
        <br>
        <div class="custom-control custom-switch">
          <label for="customSwitch1">Limit results to current region</label>
          <label class="switch">
            <input type="checkbox" checked>
            <span class="slider round"></span>
          </label>
        </div>
        <div class="mt-2" *ngIf="!(addressMain?.get('location')?.value?.coordinates && addressMain?.get('location')?.value?.coordinates.length === 2)">
          <small class="text-danger">Please select a result from Google suggestions. Manual typing is not valid and Save is disabled until a place is selected.</small>
        </div>
        <div class="form-group">
          <input class="form-control" type="text" name="streetAddress" formControlName="streetAddress"
            placeholder="Street Address" [readonly]="true">
        </div>
        <div class="form-group">
          <input class="form-control" type="text" name="city" formControlName="city" placeholder="City" [readonly]="true">
        </div>
        <div class="form-group">
          <input class="form-control" type="text" name="state" formControlName="state" placeholder="State" [readonly]="true">
        </div>
        <div class="form-group">
          <input class="form-control" type="text" name="postalCode" formControlName="postalCode"
            placeholder="Postal Code" [readonly]="true">
        </div>
        <div class="form-group">
          <input class="form-control" type="text" name="country" formControlName="country" placeholder="Country" [readonly]="true">
        </div>
        <button type="button" (click)="addAddress(addressMain.value)" [disabled]="!(addressMain?.get('location')?.value?.coordinates && addressMain?.get('location')?.value?.coordinates.length === 2)" style="margin-right: 5px;">Add</button>
      </form>
    </div>
  </ng-template>
  <ng-template #profilePolicy let-modal style="width:400px;">
    <div class="modal-body">
      <input type="radio" id="public" name="gender" value="public" [(ngModel)]="affiliation">
      <label for="male">Public</label><br>
      <input type="radio" id="private" name="gender" value="private" [(ngModel)]="affiliation">
      <label for="female">Private</label><br>
      <input type="radio" id="Fellowship" name="gender" value="fellowshipAffiliates" [(ngModel)]="affiliation">
      <label for="other">Fellowship(s)</label>
      <div class="public-button">
        <button (click)="savePolicy()" class="public sign-up-btn btn-color btn btn-primary">ok</button>
      </div>
    </div>
  </ng-template>


  <!-- modal for showing pop-up plan -->


  <ng-template #content let-modal>


    <div class="plans_modal">
      <h4 class="text-center mb-2 pb-3">{{selectedPlan?.caption}} Plan</h4>
      <h6 class="text-center mb-3">${{selectedPlan?.price}}/ {{convertSubscripitonType(selectedPlan?.days)}}</h6>
      <ul class="pl-3 mt-2 pt-1">
        <li>Robust Business Profile</li>
        <li *ngIf="selectedPlan?.caption !== 'Affiliate'">Inclusion in the Trade-in-Faith Marketplace
          (Global Visibility to all Ravel Members)</li>
        <li *ngIf="selectedPlan?.caption == 'Affiliate'">Inclusion in the Trade-in-Faith Marketplace
          (Visible to Ravel Members affiliated to the
          same primary Ministry set in your profile)</li>
        <li>Optional Participation in the Ravel Rewards Program</li>
        <li *ngIf="selectedPlan?.caption == 'Founder' || selectedPlan?.caption ==  'Community Builder'">50% off all
          Advertisements</li>
      </ul>
    </div>

  </ng-template>

  <ng-template #suggestMinistry let-modal>
    <div class="modal-header d-flex justify-content-between">
      <span class="modal-title" id="modal-basic-title">Suggest Ministry</span>
      <div type="button" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">X</span>
      </div>
    </div>
    <div class="modal-body">
      <div class="registerWrapper addInfo">
        <div class="Login">
          <div class="row">
            <div class="col-md-12 col-md-offset-3">
              <!-- <form [formGroup]="ministrySuggestionForm" class="add-ministry-basic">
                <fieldset>
                  <h4 class="fs-title w100 text-center">Ministry Basics</h4>
                  <div class="col-12">
                    <div class="form-group">
                      <label>Name</label>
                      <app-auto (setAddress)="AddressChange($event)" title="Name" strictBounds=""></app-auto>
                      <app-auto class="form-control" (setAddress)="AddressChange($event)" title="Name"></app-auto>
                    </div>

                    <div class="form-group">
                      <label>Email</label>
                      <input class="form-control " type="email" formControlName="email" name="email"
                        placeholder="Email" />
                      <div class="error-message"
                        *ngIf="submitted && ministrySuggestionForm.get('email')?.hasError('required')">
                        Required
                      </div>
                      <div class="error-message"
                        *ngIf="submitted && ministrySuggestionForm.get('email')?.hasError('pattern')">
                        Please Provide Valid Email
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Address</label>
                      <app-auto (setAddress)="getGoogleAddress($event)" [strictBounds]="boundsLimit"
                        [LatLng]="defaultBounds" adressType="geocode" title="Address"></app-auto>
                      <p>
                        <span class="error-message" *ngIf="submitted &&
                                            ministrySuggestionForm.get('address')?.hasError('required')
                                ">Required</span>
                      </p>
                    </div>

                    <div class="form-group">
                      <label>Phone</label>
                      <input class="form-control " type="text" formControlName="phone" name="phone"
                        placeholder="Phone Number" />
                    </div>

                    <div class="form-group">
                      <label>Enter Website Url</label>
                      <input class="form-control " type="text" formControlName="companyWebsite" name="webUrl"
                        placeholder="https://website.com" />
                      <p>
                        <span class="error-message" *ngIf="submitted &&
                                              ministrySuggestionForm.get('companyWebsite')?.hasError('required')
                                  ">Required</span>
                      </p>
                    </div>
                  </div>
                </fieldset>
              </form> -->
              <form [formGroup]="ministrySuggestionForm" class="add-ministry-basic">
                <fieldset>
                  <h4 class="fs-title w100 text-center">Ministry Basics</h4>
                  <div class="col-12">
                    <!-- Name field with autocomplete -->
                    <div class="form-group">
                      <label>Name</label>
                      <app-auto (setAddress)="onNameSelected($event)" title="Name" strictBounds=""></app-auto>
                    </div>

                    <!-- Address fields (auto-filled based on the selected name) -->
                    <div class="form-group">
                      <label>Address</label>
                      <input class="form-control" type="text" formControlName="formattedAddress" placeholder="Address" />
                    </div>
                    <!-- Phone and Website fields -->
                    <div class="form-group">
                      <label>Phone</label>
                      <input class="form-control" type="text" formControlName="phone" placeholder="Phone Number" />
                    </div>

                    <div class="form-group">
                      <label>Email</label>
                      <input class="form-control" type="email" formControlName="email" placeholder="Email" />
                    </div>

                    <div class="form-group">
                      <label>Enter Website Url</label>
                      <input class="form-control" type="text" formControlName="companyWebsite" placeholder="https://website.com" />
                    </div>
                  </div>
                </fieldset>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="belivers-select btn btn-color btn-outline-dark ng-star-inserted"
        (click)="onMinistrySubmit()">Save</button>
    </div>
  </ng-template>

  <!-- Social Links Modal -->
  <ng-template #socialLinksModal let-modal>
    <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <span>Add Social Links</span>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')" style="color: #fff; opacity: 1; font-size: 28px; font-weight: bold; background: transparent; border: none; cursor: pointer; padding: 0; margin: 0; line-height: 1;">
        <span aria-hidden="true" style="display: block;">×</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="form-group">
          <label for="facebookLink" class="mb-1 text-white">
            <i class="fab fa-facebook mr-2"></i>Facebook
          </label>
          <input type="text" class="form-control" formControlName="facebookLink"
            placeholder="https://facebook.com/..." name="facebookLink">
        </div>
        <div class="form-group">
          <label for="instagramLink" class="mb-1 text-white">
            <i class="fab fa-instagram mr-2"></i>Instagram
          </label>
          <input type="text" class="form-control" formControlName="instagramLink"
            placeholder="https://instagram.com/..." name="instagramLink">
        </div>
        <div class="form-group">
          <label for="youtubeLink" class="mb-1 text-white">
            <i class="fab fa-youtube mr-2"></i>YouTube
          </label>
          <input type="text" class="form-control" formControlName="youtubeLink"
            placeholder="https://youtube.com/..." name="youtubeLink">
        </div>
        <div class="form-group">
          <label for="linkedinLink" class="mb-1 text-white">
            <i class="fab fa-linkedin mr-2"></i>LinkedIn
          </label>
          <input type="text" class="form-control" formControlName="linkedinLink"
            placeholder="https://linkedin.com/..." name="linkedinLink">
        </div>
        <div class="form-group">
          <label for="tiktokLink" class="mb-1 text-white">
            <i class="fab fa-tiktok mr-2"></i>TikTok
          </label>
          <input type="text" class="form-control" formControlName="tiktokLink"
            placeholder="https://tiktok.com/..." name="tiktokLink">
        </div>
      </form>
    </div>
    <div class="modal-footer" style="display: flex; justify-content: space-between;">
      <button type="button" class="btn btn-outline-light" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button type="button" class="btn btn-color btn-outline-dark" (click)="saveSocialLinks()">Save</button>
    </div>
  </ng-template>
</span>
